import axios from "axios";

// import { SERVER_URL } from "./config";
import { SERVER_URL } from "api/config";

export default axios.create({
    baseURL: SERVER_URL
});
